/* eslint-disable react/require-default-props */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { IconButton } from "@mui/material";
import moment from "moment";
import React from "react";
import { Line } from "react-chartjs-2";
import { FormattedMessage, useIntl } from "react-intl";
import CaretLeft from "../../../../public/assets/icons/CaretLeft";
import "chart.js/auto";
import {
  handleDataTimeLine,
  handleDefaultDate,
  handleTimeLine,
  listDateBetween,
  LIST_LABEL_WEEK,
  LIST_LABEL_YEAR,
  STATIC_DATE_FORMAT
} from "../constant";
import TimeSelect from "./TimeSelect";
import LineDotIcon from "../assets/icons/LineDotIcon";
import { eventTracking } from "../../../firebase/firebaseConfig";

const handleLabelsChart = (
  type: string,
  data: any,
  filter: { first_date: moment.MomentInput; last_date: moment.MomentInput }
) => {
  if (type === "week") {
    return LIST_LABEL_WEEK;
  }
  if (type === "month") {
    const listDate = listDateBetween(
      moment(filter.first_date, STATIC_DATE_FORMAT),
      moment(filter.last_date, STATIC_DATE_FORMAT)
    );
    return listDate.map((v) => moment(v, STATIC_DATE_FORMAT).format("DD/MM"));
  }
  return LIST_LABEL_YEAR;
};
const handleHourStudyChart = (
  type: string,
  data: any[],
  filter: { first_date: moment.MomentInput; last_date: moment.MomentInput }
) => {
  const listDataReturn: any[] = [];

  if (type === "month" || type === "week") {
    const listDate = listDateBetween(
      moment(filter.first_date, STATIC_DATE_FORMAT),
      moment(filter.last_date, STATIC_DATE_FORMAT)
    );
    listDate.forEach((v, index) => {
      if (data.find((v2: { date: any }) => v2.date === v)) {
        listDataReturn[index] = Number(data.find((v2: { date: any }) => v2.date === v).finished_quiz);
      }
    });
    return listDataReturn;
  }
  let dataYear: any[] = [];
  data.forEach((v: { date: moment.MomentInput; finished_quiz: number }) => {
    if (dataYear.some((v2: any) => v2.month === moment(v.date, STATIC_DATE_FORMAT).format("MM"))) {
      dataYear = dataYear.map((v2) => {
        if (v2.month === moment(v.date, STATIC_DATE_FORMAT).format("MM")) {
          return {
            ...v2,
            finished_quiz: v2.finished_quiz + Number(v.finished_quiz)
          };
        }
        return v2;
      });
    } else {
      dataYear[moment(v.date, STATIC_DATE_FORMAT).month()] = {
        month: moment(v.date, STATIC_DATE_FORMAT).format("MM"),
        finished_quiz: Number(v.finished_quiz)
      };
    }
  });
  return dataYear.map((v) => v.finished_quiz);
};
const handleFindBiggestFinishedQuiz = (filter, data, selectOption) => {
  const listDate = handleTimeLine(
    data,
    moment(filter.first_date, STATIC_DATE_FORMAT),
    moment(filter.last_date, STATIC_DATE_FORMAT)
  );
  const listFinishedQuizBetweenDate = handleDataTimeLine(listDate, selectOption)
    ?.map((ele) => ele?.finished_quiz)
    ?.sort((a, b) => b - a);
  return listFinishedQuizBetweenDate && listFinishedQuizBetweenDate[0];
};
const handleCorrectPercentChart = (
  type: string,
  data: any[],
  filter: { first_date: moment.MomentInput; last_date: moment.MomentInput }
) => {
  const listDataReturn: any[] = [];
  if (type === "month" || type === "week") {
    const listDate = listDateBetween(
      moment(filter.first_date, STATIC_DATE_FORMAT),
      moment(filter.last_date, STATIC_DATE_FORMAT)
    );
    listDate.forEach((v, index) => {
      if (data.find((v2: { date: any }) => v2.date === v)) {
        listDataReturn[index] = {
          correct_quiz: data.find((v2: { date: any }) => v2.date === v).correct_quiz,
          finished_quiz: data.find((v2: { date: any }) => v2.date === v).finished_quiz
        };
      }
    });
    return listDataReturn.map((v) => Number(((v.correct_quiz / v.finished_quiz) * 100).toFixed(2)));
  }
  let dataYear: any[] = [];

  data?.forEach((v: { date: moment.MomentInput; correct_quiz: any; finished_quiz: any }) => {
    if (dataYear.some((v2: any) => v2.month === moment(v.date, STATIC_DATE_FORMAT).format("MM"))) {
      dataYear = dataYear.map((v2) => {
        if (v2.month === moment(v.date, STATIC_DATE_FORMAT).format("MM")) {
          return {
            ...v2,
            correct_quiz: v2.correct_quiz + v.correct_quiz,
            finished_quiz: v2.finished_quiz + v.finished_quiz
          };
        }
        return v2;
      });
    } else
      dataYear[moment(v.date, STATIC_DATE_FORMAT).month()] = {
        month: moment(v.date, STATIC_DATE_FORMAT).format("MM"),
        correct_quiz: v.correct_quiz,
        finished_quiz: v.finished_quiz
      };
  });
  return dataYear.map((v) => Number(((v.correct_quiz / v.finished_quiz) * 100).toFixed(2)));
};
function StatisticChart(props: {
  dataUserInfos?: any;
  filter: any;
  selectOption: any;
  setSelectOption?: any;
  staticData: any;
  handleAddOrSubtractFilterDay?: any;
  hideFilter?: boolean;
}) {
  const {
    dataUserInfos,
    filter,
    selectOption,
    setSelectOption,
    staticData,
    handleAddOrSubtractFilterDay,
    hideFilter = false
  } = props;
  const intl = useIntl();
  const dataByDate = React.useMemo(() => {
    return staticData?.timeline
      ? handleTimeLine(
          staticData?.timeline,
          moment(filter.first_date, STATIC_DATE_FORMAT),
          moment(filter.last_date, STATIC_DATE_FORMAT)
        )
      : [];
  }, [filter, staticData]);

  const textDayFilter = React.useMemo(() => {
    if (selectOption === "week") {
      return `${moment(filter.first_date, "YYYYMMDD").format("DD/MM")} - ${moment(filter.last_date, "YYYYMMDD").format(
        "DD/MM/YYYY"
      )}`;
    }
    if (selectOption === "month") {
      return `${moment(filter.last_date, "YYYYMMDD").format("MM/YY")}`;
    }
    return `${moment(filter.last_date, "YYYYMMDD").format("YYYY")}`;
  }, [selectOption, filter]);
  const data = React.useMemo(() => {
    return {
      labels: handleLabelsChart(selectOption, dataByDate, filter),
      datasets: [
        {
          label: intl.formatMessage({ id: "IDS_STATISTIC_NUMBER_ANSWERS" }),
          data: handleHourStudyChart(selectOption, dataByDate, filter),
          backgroundColor: "#5ABC3D",
          borderRadius: 4,
          borderColor: "#5ABC3D",
          borderWidth: 1,
          type: "bar",
          yAxisID: "y",
          fill: false,
          lineTension: 0.1,
          order: 10,
          barThickness: 30,
          maxBarThickness: 30,
          borderDash: []
        },
        {
          label: intl.formatMessage({ id: "IDS_STATISTIC_RIGHT_PERCENT" }),
          data: handleCorrectPercentChart(selectOption, dataByDate, filter),
          backgroundColor: "#2F4D9C",
          borderColor: "#2F4D9C",
          type: "line",
          yAxisID: "y1",
          borderWidth: 2,
          pointRadius: 2,
          order: 1,
          zIndex: 100,
          spanGaps: true,
          lineTension: 0.15,
          pointBorderColor: "#2F4D9C",
          pointBackgroundColor: "#2F4D9C",
          pointBorderWidth: 6,
          pointHoverRadius: 2,
          pointHoverBackgroundColor: "#5ABC3D",
          pointHoverBorderColor: "#5ABC3D",
          pointHoverBorderWidth: 6,
          pointHitRadius: 6
        }
      ],
      type: "defaultDataPoint"
    };
  }, [intl, selectOption, dataByDate, filter]);
  const config: any = {
    type: "bar",
    data,
    options: {
      responsive: true,
      stacked: false,
      plugins: {
        legend: {
          display: false
        }
      },
      elements: {
        point: {
          borderWidth: 1,
          radius: 5,
          borderColor: "#C7E6BC"
        },
        pointStyle: "line"
      },
      scales: {
        x: {
          grid: {
            display: false
          }
        },
        y: {
          type: "linear",
          display: true,
          position: "left",
          max: !handleFindBiggestFinishedQuiz(filter, staticData?.timeline, selectOption)
            ? 10
            : handleFindBiggestFinishedQuiz(filter, staticData?.timeline, selectOption),
          min: 0,
          gridLines: {
            borderDash: [8, 4]
          },
          ticks: {
            count: 6,
            autoSkip: true,
            // eslint-disable-next-line no-unused-vars
            callback: (value: number, index: any, _ticks: any) => {
              const maxValue = handleFindBiggestFinishedQuiz(filter, staticData?.timeline, selectOption);
              const step = maxValue / 5 > 0 ? maxValue / 5 : 2;
              return index === 5 ? Math.floor(value) : Math.floor(step) * index;
            },
            font: { size: 14 },
            color: "#5ABC3D"
          },
          label: {
            text: "Số câu hỏi"
          }
        },
        y1: {
          id: "y2",
          type: "linear",
          display: true,
          position: "right",
          beginAtZero: true,
          max: 100,
          min: 0,
          ticks: {
            stepSize: 20,
            // eslint-disable-next-line no-unused-vars
            callback: (value: number, _index: any, ticks: any) => {
              return value > 0 ? `${value}%` : value;
            },
            color: "#2F4D9C",
            font: { size: 14 },
            border: "1px dash "
          },
          gridLines: {
            drawOnChartArea: true
          },
          label: {
            text: "Tỉ lệ dúng"
          }
        }
      }
    }
  };

  return (
    <div className="sm:p-0 my-6 sm:w-full">
      <div className="w-full flex items-center justify-between mb-1">
        <span className="sm:px-2 md:px-0 text-lg font-semibold ">
          <FormattedMessage id="IDS_STATISTIC_SUM_TABLE" />
        </span>
        {!hideFilter && (
          <TimeSelect
            value={selectOption}
            onChange={(val: any) =>
              eventTracking("select_statitistic_view_type", { view_type: `${val}ly` }, () => setSelectOption(val))
            }
          />
        )}
      </div>
      {!hideFilter && (
        <div className="md:w-full sm:w-screen flex sm:justify-center">
          <div className="flex flex-row justify-between">
            <div className="flex flex-row items-center justify-center flex-1 border border-gray max-w-[220px] rounded-[20px]">
              <div style={{ transform: "rotate(90deg)" }}>
                <IconButton
                  disabled={dataUserInfos.member?.created_at > moment(filter.first_date).unix()}
                  onClick={() => handleAddOrSubtractFilterDay("subtract")}
                >
                  <CaretLeft />
                </IconButton>
              </div>

              <span className="font-semibold text-[13px]">{textDayFilter}</span>
              <div style={{ transform: "rotate(-90deg)" }}>
                <IconButton
                  disabled={filter.last_date === handleDefaultDate(selectOption)?.last_date}
                  onClick={() => handleAddOrSubtractFilterDay("add")}
                  className="disabled:cursor-not-allowed"
                >
                  <CaretLeft />
                </IconButton>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="flex items-center justify-between w-full text-[10px] text-gray400 px-3 mb-1">
        <span>Số câu hỏi</span>
        <span>Tỷ lệ đúng</span>
      </div>
      <div className="px-2">
        <Line {...config} />
      </div>
      <div className="flex w-full justify-end px-4 gap-x-4 items-center mt-3">
        <div className="flex flex-row flex-nowrap gap-2 items-center">
          <div className="w-[25px] h-[25px] bg-green rounded-md" />
          <span className="text-[10px]">
            <FormattedMessage id="total.num.quiz.finished" />
          </span>
        </div>
        <div className="flex flex-row flex-nowrap gap-2 items-center">
          <LineDotIcon />
          <span className="text-[10px]">
            <FormattedMessage id="chart.description.correct" />
          </span>
        </div>
      </div>
    </div>
  );
}

export default StatisticChart;
